"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setCheckOffertaListener = exports.setFetchSuppliersListener = exports.setAllSuppliersListener = exports.setSelectedSupplierIdListener = exports.setSelectedSupplierListener = void 0;
var databus_1 = require("@portals/databus");
var constants_1 = require("./constants");
var setSelectedSupplierListener = function (listener) {
    new databus_1.Databus({ name: constants_1.SELECTED_SUPPLIER }).addEventListener({
        listener: listener,
    });
};
exports.setSelectedSupplierListener = setSelectedSupplierListener;
var setSelectedSupplierIdListener = function (listener) {
    new databus_1.Databus({ name: constants_1.SELECTED_SUPPLIER_ID }).addEventListener({
        listener: listener,
    });
};
exports.setSelectedSupplierIdListener = setSelectedSupplierIdListener;
var setAllSuppliersListener = function (listener) {
    new databus_1.Databus({ name: constants_1.ALL_SUPPLIERS }).addEventListener({
        listener: listener,
    });
};
exports.setAllSuppliersListener = setAllSuppliersListener;
var setFetchSuppliersListener = function (listener) {
    new databus_1.Databus({ name: constants_1.FETCH_SUPPLIERS }).addEventListener({
        listener: listener,
    });
};
exports.setFetchSuppliersListener = setFetchSuppliersListener;
var setCheckOffertaListener = function (listener) {
    new databus_1.Databus({ name: constants_1.CHECK_OFFERTA }).addEventListener({
        listener: listener,
    });
};
exports.setCheckOffertaListener = setCheckOffertaListener;
